// @generated
// This file is automatically generated by Kanel. Do not modify manually.

/** Represents the enum public.sample_type */
enum SampleType {
  bulk = 'bulk',
  singleCell = 'singleCell',
};

export default SampleType;
